import {gemStore} from 'app/gemStore';

export const setLazyLoadPageAction = (lazyLoadPage: boolean) => gemStore.getState().setLazyLoadPage(lazyLoadPage);
